export default "__VITE_ASSET__BRIX_1ir__"